import { render } from "./LaporanTerimaanMukim.vue?vue&type=template&id=53d901b2"
import script from "./LaporanTerimaanMukim.vue?vue&type=script&lang=js"
export * from "./LaporanTerimaanMukim.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__